export default {
    data () {
        return {
            gridKey: 0
        }
    },

    // changing key will re-render component thus fixing height on browser resize
    watch: {
        "$vuetify.breakpoint.name": function () {
            this.gridKey++
        }
    }
}
